import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {AssigneesResponse as AssigneesData} from '@github-ui/dotcom-schema/types/pull_requests/v1/assignees'
import type {DevelopmentResponse as DevelopmentData} from '@github-ui/dotcom-schema/types/pull_requests/v1/development'
import type {LabelsResponse as LabelsData} from '@github-ui/dotcom-schema/types/pull_requests/v1/labels'
import {pullRequestsAppBuilder} from '../config/app-builder'
import type {OverviewRoutePayload} from './route-payload-types'
import type {ReviewRequestsData} from '../page-data/payloads/review-requests'
import {pageDataQuery} from './page-data-query'
import {assigneesQueryFn} from '../page-data/loaders/assignees-query'
import {developmentQueryFn} from '../page-data/loaders/development-query'
import {labelsQueryFn} from '../page-data/loaders/labels-query'

export const pullRequestsOverviewRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsOverviewRoute', {
  path: '/:owner/:repo/pull/:pr_number/overview',
  queries: [
    mainQuery<OverviewRoutePayload>(),
    pageDataQuery<ReviewRequestsData, 'review_requests'>('review_requests', true),
    pageDataQuery<AssigneesData, 'assignees'>('assignees', true, {queryFn: assigneesQueryFn}),
    pageDataQuery<DevelopmentData, 'development'>('development', true, {queryFn: developmentQueryFn}),
    pageDataQuery<LabelsData, 'labels'>('labels', true, {queryFn: labelsQueryFn}),
  ],
})
